import React from "react";
import { NavBar2 as Nav } from "nq-component";
import { useLocation } from "react-router-dom";
import NavBar2 from "../NavBar2";

function NavBar1(props) {
  const [collapsed, setCollapsed] = React.useState(false);
  const location = useLocation();

  function onClickNavigate() {
    setCollapsed(!collapsed);
  }

  React.useEffect(() => {
    setCollapsed(false);
  }, [location]);

  return (
    <NavBar2
      className="shadow-sm"
      logo="/logo.svg"
      onClickNavigate={onClickNavigate}
      {...props}
    />
  );
}

export default NavBar1;
